import React, { useEffect, useState } from "react";
import { getappCalcApis } from "../../../graphs/appCalculator/appcalcApis";
import { useSelector } from "react-redux";
import DeleteModal from "../../../components/ui/modal/DeleteModal";
import DataTable from "react-data-table-component";

const ContactUs = () => {
  const [contactUsData, setContactUsData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [serachInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPageOptions = [10, 20, 50, 100];
  const rowsPerPage = 10;
  const AuthToken = useSelector((state) => state?.auth?.authToken);
  const tempData = [{}, {}, {}, {}, {}, {}];

  const contactUsHandler = async () => {
    try {
      await getappCalcApis(AuthToken, "contactus").then((res) => {
        console.log(res);
        setContactUsData(res?.data?.data);
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleSearch = (e) => {
    console.log("search value => ", e);

    e.preventDefault();
    const searchTerm = e.target.value;
    setSearchInput(searchTerm);
    console.log(searchTerm);
    if (searchTerm !== "") {
      const filteredData = contactUsData.filter(
        (ele) =>
          ele?.cont_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          ele?.cont_email?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setContactUsData(filteredData);
    } else {
      contactUsHandler();
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const columns = [
    {
      name: "Sr. No",
      center: true,
      width: "70px",
      selector: (row, index) => index + 1 + (currentPage - 1) * rowsPerPage,
    },
    {
      name: "Name",
      sortable: true,
      center: true,
      selector: (row) => row?.cont_name,
    },
    {
      name: "Email",
      sortable: true,
      center: true,
      selector: (row) => <p className="break-words whitespace-break-spaces">{row?.cont_email}</p>,
    },
    {
      name: "Phone",
      center: true,
      selector: (row) => row?.cont_mb_no,
    },
    {
      name: "Website",
      width: "250px",
      center: true,
      selector: (row) => row?.cont_website,
    },
    {
      name: "Message",
      width: "300px",
      center: true,
      cell: (row) => (
        <p className=" overflow-y-auto  max-h-24 overflow-hidden py-1 ">
          {row?.cont_brief}
        </p>
      ),
      // selector: (row) => (row?.cont_brief)
    },
    {
      name: "Recieved",
      // sortable: true,
      center: true,
      selector: (row) => <p className="break-words whitespace-break-spaces">{row?.cont_create_date}</p> ,
    },
    {
      name: "Action",
      width: "100px",
      cell: (ele) => (
        <div className="p-2 ">
          <div
            className="inline-block cursor-pointer"
            onClick={() => {
              setDeleteId(ele?.cont_id);
              setDeleteModal(true);
            }}
          >
            <svg
              width="20"
              height="20"
              viewbox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.33333 15C8.55435 15 8.76631 14.9122 8.92259 14.7559C9.07887 14.5996 9.16667 14.3877 9.16667 14.1667V9.16666C9.16667 8.94564 9.07887 8.73368 8.92259 8.5774C8.76631 8.42112 8.55435 8.33332 8.33333 8.33332C8.11232 8.33332 7.90036 8.42112 7.74408 8.5774C7.5878 8.73368 7.5 8.94564 7.5 9.16666V14.1667C7.5 14.3877 7.5878 14.5996 7.74408 14.7559C7.90036 14.9122 8.11232 15 8.33333 15ZM16.6667 4.99999H13.3333V4.16666C13.3333 3.50362 13.0699 2.86773 12.6011 2.39889C12.1323 1.93005 11.4964 1.66666 10.8333 1.66666H9.16667C8.50363 1.66666 7.86774 1.93005 7.3989 2.39889C6.93006 2.86773 6.66667 3.50362 6.66667 4.16666V4.99999H3.33333C3.11232 4.99999 2.90036 5.08779 2.74408 5.24407C2.5878 5.40035 2.5 5.61231 2.5 5.83332C2.5 6.05434 2.5878 6.2663 2.74408 6.42258C2.90036 6.57886 3.11232 6.66666 3.33333 6.66666H4.16667V15.8333C4.16667 16.4964 4.43006 17.1322 4.8989 17.6011C5.36774 18.0699 6.00363 18.3333 6.66667 18.3333H13.3333C13.9964 18.3333 14.6323 18.0699 15.1011 17.6011C15.5699 17.1322 15.8333 16.4964 15.8333 15.8333V6.66666H16.6667C16.8877 6.66666 17.0996 6.57886 17.2559 6.42258C17.4122 6.2663 17.5 6.05434 17.5 5.83332C17.5 5.61231 17.4122 5.40035 17.2559 5.24407C17.0996 5.08779 16.8877 4.99999 16.6667 4.99999ZM8.33333 4.16666C8.33333 3.94564 8.42113 3.73368 8.57741 3.5774C8.73369 3.42112 8.94565 3.33332 9.16667 3.33332H10.8333C11.0543 3.33332 11.2663 3.42112 11.4226 3.5774C11.5789 3.73368 11.6667 3.94564 11.6667 4.16666V4.99999H8.33333V4.16666ZM14.1667 15.8333C14.1667 16.0543 14.0789 16.2663 13.9226 16.4226C13.7663 16.5789 13.5543 16.6667 13.3333 16.6667H6.66667C6.44565 16.6667 6.23369 16.5789 6.07741 16.4226C5.92113 16.2663 5.83333 16.0543 5.83333 15.8333V6.66666H14.1667V15.8333ZM11.6667 15C11.8877 15 12.0996 14.9122 12.2559 14.7559C12.4122 14.5996 12.5 14.3877 12.5 14.1667V9.16666C12.5 8.94564 12.4122 8.73368 12.2559 8.5774C12.0996 8.42112 11.8877 8.33332 11.6667 8.33332C11.4457 8.33332 11.2337 8.42112 11.0774 8.5774C10.9211 8.73368 10.8333 8.94564 10.8333 9.16666V14.1667C10.8333 14.3877 10.9211 14.5996 11.0774 14.7559C11.2337 14.9122 11.4457 15 11.6667 15Z"
                fill="#E85444"
              ></path>
            </svg>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    contactUsHandler();
  }, [deleteId, deleteModal]);
  return (
    <section className="py-8">
      <div className="px-4">
        <div className="flex flex-wrap gap-2 items-center justify-between p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          <div className="flex items-center">
            <h2 className="lg:text-lg lg:font-medium md:text-lg md:font-medium sm:text-base sm:font-medium text-base font-medium">Contact Us</h2>
            <span className="ml-2 border-2 rounded-full border-yellow-400">
              <span className=" p-2 text-sm">
                {contactUsData?.length ? contactUsData?.length : ""}
              </span>
            </span>
          </div>
          <div className="flex items-center justify-center">
            <div className="w-full md:w-1/2 lg:w-auto flex pr-4 mb-4 md:mb-0 md:mr-4 md:ml-auto border rounded-lg bg-white">
              <input
                onChange={(e) => handleSearch(e)}
                className="py-2 pl-4  pr-2 text-sm rounded-lg placeholder-gray-500 focus:outline-0 w-64"
                type="text"
                placeholder="Search..."
              />
              <button className="ml-auto">
                <svg
                  className="text-rose-500"
                  width="20"
                  height="20"
                  viewbox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.0921 16.9083L15.0004 13.8417C16.2005 12.3453 16.7817 10.4461 16.6244 8.53441C16.4672 6.62274 15.5835 4.84398 14.155 3.56386C12.7265 2.28375 10.8619 1.59958 8.94451 1.65205C7.02711 1.70452 5.20268 2.48963 3.84636 3.84594C2.49004 5.20226 1.70493 7.02669 1.65247 8.94409C1.6 10.8615 2.28416 12.7261 3.56428 14.1546C4.84439 15.583 6.62316 16.4668 8.53482 16.624C10.4465 16.7812 12.3457 16.2001 13.8421 15L16.9087 18.0667C16.9862 18.1448 17.0784 18.2068 17.1799 18.2491C17.2815 18.2914 17.3904 18.3132 17.5004 18.3132C17.6104 18.3132 17.7193 18.2914 17.8209 18.2491C17.9224 18.2068 18.0146 18.1448 18.0921 18.0667C18.2423 17.9113 18.3262 17.7036 18.3262 17.4875C18.3262 17.2714 18.2423 17.0637 18.0921 16.9083ZM9.16708 15C8.01335 15 6.88554 14.6579 5.92625 14.0169C4.96696 13.3759 4.21929 12.4649 3.77778 11.399C3.33627 10.3331 3.22075 9.16019 3.44583 8.02863C3.67091 6.89708 4.22648 5.85767 5.04229 5.04187C5.85809 4.22606 6.89749 3.67049 8.02905 3.44541C9.1606 3.22033 10.3335 3.33585 11.3994 3.77736C12.4653 4.21887 13.3763 4.96654 14.0173 5.92583C14.6583 6.88512 15.0004 8.01293 15.0004 9.16666C15.0004 10.7138 14.3858 12.1975 13.2919 13.2914C12.1979 14.3854 10.7142 15 9.16708 15Z"
                    fill="#382CDD"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container px-4 mx-auto">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full lg:w-full px-4 mb-8 lg:mb-0">
            <div className="p-4 mb-6 bg-white shadow-xl border w-full rounded overflow-x-auto">
              <DataTable
                columns={columns}
                data={contactUsData}
                pagination={true}
                striped
                onChangePage={handlePageChange}
                paginationRowsPerPageOptions={rowsPerPageOptions}
              />

              {/* <table className="table-auto w-full ">
                <thead>
                  <tr className="text-sm text-gray-500 text-left bg-slate-100">
                    <th className="pl-6 pb-3 font-medium border">Sr No</th>
                    <th className="pb-3 font-medium p-2 border">Name</th>
                    <th className="pb-3 font-medium p-2 border">Email</th>
                    <th className="pb-3 font-medium p-2 border">Phone</th>
                    <th className="pb-3 font-medium p-2 border">Website</th>
                    <th className="pb-3 font-medium p-2 border">Message</th>
                    <th className="pb-3 font-medium p-2 border ">Recieved</th>
                    <th className="pb-3 font-medium p-2 border">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {contactUsData?.map((ele, idx) => {
                    return (
                      <tr key={idx} className="text-xs bg-gray-50">
                        <td className="py-5 px-6 font-medium border">
                          {idx + 1}
                        </td>
                        <td className="font-medium p-2 border">
                          {ele?.cont_name}
                        </td>
                        <td className="font-medium p-2 border">
                          {ele?.cont_email}{" "}
                        </td>
                        <td className="font-medium p-2 border">
                          {" "}
                          {ele?.cont_mb_no}
                        </td>
                        <td className="font-medium p-2 border">
                          {ele?.cont_website}{" "}
                        </td>
                        <td className="font-medium p-2 border">
                          {ele?.cont_brief}
                        </td>
                        <td className="font-medium p-2 border">
                          {ele?.cont_create_date}
                        </td>
                        <td className="p-2 border">
                          <div
                            className="inline-block cursor-pointer"
                            onClick={() => {
                              setDeleteId(ele?.cont_id);
                              setDeleteModal(true);
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewbox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.33333 15C8.55435 15 8.76631 14.9122 8.92259 14.7559C9.07887 14.5996 9.16667 14.3877 9.16667 14.1667V9.16666C9.16667 8.94564 9.07887 8.73368 8.92259 8.5774C8.76631 8.42112 8.55435 8.33332 8.33333 8.33332C8.11232 8.33332 7.90036 8.42112 7.74408 8.5774C7.5878 8.73368 7.5 8.94564 7.5 9.16666V14.1667C7.5 14.3877 7.5878 14.5996 7.74408 14.7559C7.90036 14.9122 8.11232 15 8.33333 15ZM16.6667 4.99999H13.3333V4.16666C13.3333 3.50362 13.0699 2.86773 12.6011 2.39889C12.1323 1.93005 11.4964 1.66666 10.8333 1.66666H9.16667C8.50363 1.66666 7.86774 1.93005 7.3989 2.39889C6.93006 2.86773 6.66667 3.50362 6.66667 4.16666V4.99999H3.33333C3.11232 4.99999 2.90036 5.08779 2.74408 5.24407C2.5878 5.40035 2.5 5.61231 2.5 5.83332C2.5 6.05434 2.5878 6.2663 2.74408 6.42258C2.90036 6.57886 3.11232 6.66666 3.33333 6.66666H4.16667V15.8333C4.16667 16.4964 4.43006 17.1322 4.8989 17.6011C5.36774 18.0699 6.00363 18.3333 6.66667 18.3333H13.3333C13.9964 18.3333 14.6323 18.0699 15.1011 17.6011C15.5699 17.1322 15.8333 16.4964 15.8333 15.8333V6.66666H16.6667C16.8877 6.66666 17.0996 6.57886 17.2559 6.42258C17.4122 6.2663 17.5 6.05434 17.5 5.83332C17.5 5.61231 17.4122 5.40035 17.2559 5.24407C17.0996 5.08779 16.8877 4.99999 16.6667 4.99999ZM8.33333 4.16666C8.33333 3.94564 8.42113 3.73368 8.57741 3.5774C8.73369 3.42112 8.94565 3.33332 9.16667 3.33332H10.8333C11.0543 3.33332 11.2663 3.42112 11.4226 3.5774C11.5789 3.73368 11.6667 3.94564 11.6667 4.16666V4.99999H8.33333V4.16666ZM14.1667 15.8333C14.1667 16.0543 14.0789 16.2663 13.9226 16.4226C13.7663 16.5789 13.5543 16.6667 13.3333 16.6667H6.66667C6.44565 16.6667 6.23369 16.5789 6.07741 16.4226C5.92113 16.2663 5.83333 16.0543 5.83333 15.8333V6.66666H14.1667V15.8333ZM11.6667 15C11.8877 15 12.0996 14.9122 12.2559 14.7559C12.4122 14.5996 12.5 14.3877 12.5 14.1667V9.16666C12.5 8.94564 12.4122 8.73368 12.2559 8.5774C12.0996 8.42112 11.8877 8.33332 11.6667 8.33332C11.4457 8.33332 11.2337 8.42112 11.0774 8.5774C10.9211 8.73368 10.8333 8.94564 10.8333 9.16666V14.1667C10.8333 14.3877 10.9211 14.5996 11.0774 14.7559C11.2337 14.9122 11.4457 15 11.6667 15Z"
                                fill="#E85444"
                              ></path>
                            </svg>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table> */}
            </div>
          </div>
        </div>
      </div>
      <DeleteModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        deleteId={deleteId}
        type={"contactus"}
        title={"contactus"}
      />
    </section>
  );
};

export default ContactUs;
